<script lang="ts">
  import { pop } from "svelte-spa-router";
  import Separator from "$shared/components/Separator.svelte";
  import { onMount } from "svelte";
  import { type Debtor, type MyPagesStart } from "../../../apis/parkito";
  import DebtorInvoices from "$shared/components/parkito/debtors/DebtorInvoices.svelte";

  export let params: { id: string | undefined };
  export let myPagesData: SvelteStore<MyPagesStart> | undefined;
  let debtor: Debtor | undefined = undefined;

  onMount(() => {
    if (import.meta.env.DEV) console.log("Invoices mounted.");
  });

  $: {
    if ($myPagesData) {
      debtor = $myPagesData.debtors.find(
        (d: any) => d.debtor.id === params.id,
      )?.debtor;
    }
  }
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px]"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Fakturor
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  {#if debtor !== undefined}
    <DebtorInvoices {debtor} />
  {/if}
</div>
